import { render, staticRenderFns } from "./MunicipalEcoTimeseries.vue?vue&type=template&id=2989a1d7&scoped=true"
import script from "./MunicipalEcoTimeseries.vue?vue&type=script&lang=js"
export * from "./MunicipalEcoTimeseries.vue?vue&type=script&lang=js"
import style0 from "./MunicipalEcoTimeseries.vue?vue&type=style&index=0&id=2989a1d7&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2989a1d7",
  null
  
)

export default component.exports